import React from "react";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import "../css/petParentCard.css"
import axios from "axios";




function PetParentCard() {

  const [petData, setPetData] = useState([]);
  const [busy, setBusy] = useState(false);

  const navigate = useNavigate();






  const params = useParams();
  const email = params.email;


  const handleButton = async (value) => {
    try {
      setBusy(true)
      await axios.post(`https://petme.onrender.com/user/mailSender?email=${email}`, { value });
      setBusy(false)
      console.log('Email sent successfully');
      navigate("/PetParentTable")
    } catch (error) {
      console.error('Error sending email:', error);
    }
  }


  const fetchPetData = async () => {
    try {
      const response = await fetch(`https://petme.onrender.com/api/pets/findPet?email=${email}`)
      const data = await response.json();
      setPetData(data[0])
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    fetchPetData();
  }, []);


  if (busy) {
    <h1>plese wait......</h1>
  }


  return (
    <div>


      <section className="parentCard-section">

        <div className="column parentCardColumn">
          <h2 className="parentCard-heading">Pet Parent Details</h2>
          <div className="row parentCardRow">
            <div className="parentCart-detailsDiv">
              <p className="parentCardDetails parentName">Parent Name: <span className="parentCard-detailsValue">{petData.ownername}</span></p>
              <p className="parentCardDetails parentEmail">Email: <span className="parentCard-detailsValue">{petData.email}</span></p>
              <p className="parentCardDetails parentPettName">Pet Name: <span className="parentCard-detailsValue">{petData.petname}</span></p>
              <p className="parentCardDetails dateOfApplication-parent">Date Of Application: <span className="parentCard-detailsValue"></span></p>
              {!petData.verified && (<div className="parentCard-btnDiv">
                <button className="parentCardBtn parentCard-approveBtn" onClick={() => handleButton('verified')} >APPROVED</button>
                <button className="parentCardBtn parentCard-rejectBtn" onClick={() => handleButton('notverified')} >REJECTED</button>
              </div>)}

              {petData.verified && (
                <h2 className="parentCard-verificationMsg">Pet is ready to be loved and cherished.</h2>
              )}
            </div>
            <div className="parentCard-petImgDiv" >
              <img className="parentCard-petImg" src={petData.petImageUrl} alt="pet_image" />
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}

export default PetParentCard
